import { render, staticRenderFns } from "./SocialsPreloader.vue?vue&type=template&id=caa62416&lang=pug&"
import script from "./SocialsPreloader.vue?vue&type=script&lang=js&"
export * from "./SocialsPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports